import Component from '../inherited/Component'
import slick from 'slick-carousel'
import $ from 'jquery'
import Helpers from '../lib/Helpers'
import imagesLoaded from 'imagesloaded'

export default class Slider extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._options = {...{
      slidesToShow: 1,
      rows: 0,
      swipeToSlide: true,
      mount: true
    }, ...this._options}
    this._isMounted = false
  }

  mount () {
    if (this._options.enableWhen && !matchMedia(`only screen and ${this._options.enableWhen}`).matches) {
      window.addEventListener('resize', e => {
        if (matchMedia(`only screen and ${this._options.enableWhen}`).matches && !this._isMounted) {
          this.mount()
        } else if(!matchMedia(`only screen and ${this._options.enableWhen}`).matches && this._isMounted) {
          this.unmount()
          this._isMounted = false
        }
      }, { passive: true })
      return false
    }
    if (this._options.mount === false) {
      return false
    }

    this._isMounted = true

    $(this._elem).on('init', (e, slider) => {
      $.each(slider.$dots, (i, el) => {
        $(el).find('li').eq(slider.currentSlide).addClass('slick-active');
      })
      if (slider.slickGetOption('autoplayOnScroll')) {
        this._setAutoplayOnScroll()
      }
    })
    $(this._elem).slick(this._options)

    $(this._elem).on( 'afterChange', function( event, slick, currentSlide) {
      $.each(slick.$dots, (i, el) => {
        $(el).find('li').eq(currentSlide).addClass('slick-active');
      })
    });

    imagesLoaded(this._elem, () => {
      $(this._elem).slick('setPosition')
    })
  }

  unmount () {
    $(this._elem).slick('unslick')
  }

  _setAutoplayOnScroll () {
    requestAnimationFrame(this._doAutoplayCalculations.bind(this))
  }

  _doAutoplayCalculations () {
    if(Helpers.isInViewport(this._elem) && $(this._elem).slick('slickGetOption', 'autoplay') === false) {
      $(this._elem).slick('slickSetOption', 'autoplay', true, true)
      $(this._elem).slick('slickPlay')
    } else if (!Helpers.isInViewport(this._elem) && $(this._elem).slick('slickGetOption', 'autoplay') === true) {
      $(this._elem).slick('slickSetOption', 'autoplay', false, true)
      $(this._elem).slick('slickPause')
    }
    requestAnimationFrame(this._doAutoplayCalculations.bind(this))
  }

  getSpeed () {
    return parseFloat($(this._elem).slick('slickGetOption', 'speed'))
  }

  goToSlide (i, dontAnimate=false) {
    $(this._elem).slick('slickGoTo', i, dontAnimate)
  }
}